/* eslint-disable no-param-reassign */
import { graphql, useStaticQuery } from "gatsby"

export default function (articleId) {
  const { allClass, allShopifyProduct } = useStaticQuery(
    graphql`
      query {
        allClass(filter: { active: { eq: true }, availableForPurchase: { eq: true } }) {
          nodes {
            ... on Class {
              id
              classId
              title
              price
              instructorByline
              shortDescription
              url
              image
              availableForPurchase
            }
          }
        }
        allShopifyProduct(filter: { isGiftCard: { eq: false }, status: { eq: ACTIVE } }) {
          nodes {
            ... on ShopifyProduct {
              legacyResourceId
              title
              description
              onlineStoreUrl
              featuredImage {
                originalSrc
              }
              priceRangeV2 {
                maxVariantPrice {
                  amount
                }
              }
              meta_testimonial: metafield(key: "testimonial", namespace: "mbg_com") {
                value
              }
              meta_testimonial_attribution: metafield(
                key: "testimonial_attribution"
                namespace: "mbg_com"
              ) {
                value
              }
              meta_testimonial_video_id: metafield(
                key: "testimonial_video_id"
                namespace: "mbg_com"
              ) {
                value
              }
              meta_related_article_title: metafield(key: "title", namespace: "related_article") {
                value
              }
              meta_related_article_url: metafield(key: "url", namespace: "related_article") {
                value
              }
              meta_related_article_image: metafield(key: "image", namespace: "related_article") {
                value
              }
              review {
                ... on OkendoProductReview {
                  ...okendoProductReviewFields
                }
              }
            }
          }
        }
      }
    `,
  )

  const shopifyProducts = allShopifyProduct.nodes.map((node) => node)

  const { nodes: classes } = allClass
  try {
    // parse class images and add itc_content to class urls
    classes.forEach((node) => {
      if (node.url) {
        const separator = node.url.includes("?") ? "&" : "?"
        node.url = `${node.url}${separator}itc_content=${articleId}`
      }
      node.image = JSON.parse(node.image)
    })
  } catch (err) {}
  try {
    shopifyProducts.forEach((product) => {
      // add metafields to product
      product.subtitle = product.description
      try {
        product.subtitle = product.subtitle.replace(/(<([^>]+)>)/gi, "")
      } catch (err) {}
      product.price = product.priceRangeV2?.maxVariantPrice?.amount
      product.url = product.onlineStoreUrl
      if (product.url) {
        const separator = product.url.includes("?") ? "&" : "?"
        product.url = `${product.url}${separator}itc_content=${articleId}`
      }
      product.image = product.featuredImage ? product.featuredImage.originalSrc : null

      if (
        product.meta_related_article_title?.value &&
        product.meta_related_article_url.value &&
        product.meta_related_article_image.value
      ) {
        try {
          product.relatedArticle = {
            title: JSON.parse(product.meta_related_article_title.value)[0],
            url: JSON.parse(product.meta_related_article_url.value)[0],
            image: JSON.parse(product.meta_related_article_image.value)[0],
          }
        } catch (err) {
          // ignore
        }
      }
    })

    return {
      shopifyProducts,
      classes,
    }
  } catch (err) {
    console.log(err)
  }
}
